import {
  PrimitiveValueType,
  RowDataReducerAction,
  RowDataReducerState,
} from "../../../../../types";
import { ROW_DATA_KEYS } from "../../../constants";

const APPLICABLE_PAY_PERIOD_TYPES = ["SEMI-MONTHLY", "MONTHLY", "BI-WEEKLY"];

export const handleEnableOrDisableForIsPriorDaysUseForOT = (
  propertyKey: string,
  inputValue: PrimitiveValueType,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
) => {
  const { rowData } = rowDataReducerState;

  if (
    propertyKey !== ROW_DATA_KEYS.PAY_PERIOD_TYPE &&
    propertyKey !== ROW_DATA_KEYS.IS_OVERTIME_CALCULATED
  ) {
    return;
  }

  const isOverTimeCalculated =
    propertyKey === ROW_DATA_KEYS.IS_OVERTIME_CALCULATED
      ? inputValue === true
      : rowData[ROW_DATA_KEYS.IS_OVERTIME_CALCULATED] === true;

  const payPeriodType =
    propertyKey === ROW_DATA_KEYS.PAY_PERIOD_TYPE
      ? inputValue
      : rowData[ROW_DATA_KEYS.PAY_PERIOD_TYPE];

  const shouldEnable =
    isOverTimeCalculated &&
    APPLICABLE_PAY_PERIOD_TYPES.includes(payPeriodType as string);

  dispatch({
    type: "UPDATE_SCHEMA_PROPERTY_FIELD",
    payload: {
      propertyKey: ROW_DATA_KEYS.IS_PRIOR_DAYS_USE_FOR_OT,
      propertyField: "disabled",
      newPropertyFieldValue: !shouldEnable,
    },
  });

  if (!shouldEnable) {
    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey: ROW_DATA_KEYS.IS_PRIOR_DAYS_USE_FOR_OT,
        newFieldValue: false,
      },
    });
  }
};
